import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

export interface TabProps extends MuiTabProps {
  className?: string;
}

const TabImpl: React.FC<TabProps> = ({ className, ...props }) => {
  return <MuiTab className={className} {...props} />;
};

/**
 * Customized MUI Tab component.
 *
 * It inherits all properties of a MUI Tab
 */
export const Tab = muiStyled(TabImpl)(
  ({ theme }) => css`
    /* Many styling overrides are defined in mui-theme.tsx */

    &.MuiTab-root {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px;
      border-radius: 8px 8px 0px 0px;
      flex: none;
      order: 1;
      flex-grow: 0;
      &.Mui-selected {
        background: ${theme.palette.background.paper};
      }
      &:not(.Mui-selected) {
        color: ${theme.palette.text.secondary};
      }
    }
  `
);
export default Tab;
